<template>
  <div>

    <div class="row" v-if="activeSchemes == 0">
      <div class="col">
        <div class="alert alert-info">
          Welcome.  Please read the user guide below to get started, on creating your first scheme. <strong><router-link :to="{name:'schemes'}">Create a Scheme</router-link></strong> .
        </div>
      </div>
    </div>
    

    <div class="row">
      <div class="col-md-4">
    
        <router-link
         v-if="userHasPerms(['Manage contributions'])"
          :to="{ name: 'contributions-outstanding' }"
          class="btn btn-primary py-3 mt-1 w-50 border-right"
        >
          <i class="lni lni-revenue font-size-26"></i>
          <div class="py-1"><!-- --></div>
          Outstanding <br> Contributions</router-link
        >

        <router-link
         v-if="userHasPerms(['Manage contributors'])"
          :to="{ name: 'contributors-create' }"
          class="btn btn-primary py-3 mt-1 w-50 border-right"
        >
          <i class="lni lni-consulting font-size-26"></i>
          <div class="py-1"><!-- --></div>
          Create <br> Contributor</router-link
        >

        <vuescroll style="height: 600px;" class="my-3">
          <div class="card px-3 py-4 box-shadow">
            <h4 class="font-weight-500 mb-4">Activities</h4>

            <span v-for="n in notifications" :key="n.id">
              <div class="row border-bottom py-3">
                <div class="col-auto">
                  <b-avatar
                    :size="12"
                    :variant="notificationVariant(n.level)"
                    text="."
                  ></b-avatar>
                </div>
                <div class="col">
                  <p class="m-0 p-0">{{ n.message }}</p>
                  <small class="text-muted">
                    {{
                      moment(new Date(n.created_at)).format("DD MMM YY, HH:mm")
                    }}
                  </small>
                </div>
                
              </div>
            </span>
          </div>
        </vuescroll>
      </div>

      <div class="col-md-8">
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ activeSchemes }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-success">
                      <div class="circle-icon">
                        <i
                          class="lni lni-bricks text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Active Schemes</p>
              </div>
            </div>
          </div>

        
          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ activeContributors }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-success">
                      <div class="circle-icon">
                        <i
                          class="lni lni-customer text-white font-size-26"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Active Contributors</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ weeklyCollected | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-success">
                      <div class="circle-icon">
                        <i class="lni lni-money-location text-white font-size-26"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Collected this week</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h2 class="text-primary font-weight-bold text-monospace">
                      {{ monthlyCollected | currency }}
                    </h2>
                  </div>
                  <div class="col-auto">
                    <div class="circle-icon-con bg-success">
                      <div class="circle-icon">
                        <i class="lni lni-money-location text-white font-size-26"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold">Collected pass 30 days</p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="card p-3 ">
              
              <h3 class="my-3">User Guide</h3>


               <user-guide></user-guide>

    
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import homeRepo from "@/api/repos/homeRepo";
import vuescroll from 'vuescroll';
import userGuide from './../../components/common/UserGuide.vue'

export default {
  components: {
   vuescroll,
   userGuide
  },
  data() {
    return {
      organisation_id: localStorage.getItem("current_organisation_id"),
      notifications: [],
      activeSchemes: 0,
      activeContributors: 0,
      monthlyCollected: 0,
      weeklyCollected: 0,
    };
  },

  mounted() {
    this.getData();
    this.timer = setInterval(this.getData, 60000);
  },

  methods: {
    notificationVariant(level) {
      if (level == 1) {
        return "success";
      } else if (level == 2) {
        return "info";
      } else if (level == 3) {
        return "warning";
      } else {
        return "danger";
      }
    },
    async getData() {
      try {
        let { data } = await homeRepo.home();
        this.notifications = data.notifications;
        this.activeSchemes = data.active_schemes;
        this.activeContributors = data.active_contributors;
        this.monthlyCollected = data.monthly_collected;
        this.weeklyCollected = data.weekly_collected;
      } catch (e) {
        if (this.timer) clearInterval(this.timer);
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.timer) clearInterval(this.timer);
    next();
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    organisations() {
      return this.$store.state.user.organisations;
    },
    current_organisation_id() {
      return this.$store.state.user.current_organisation_id;
    },
    cc() {
      return this.organisations.filter(
        (c) => c.id == this.current_organisation_id
      )[0];
    },
  },
};
</script>

<style>
.circle-icon-con {
  height: 70px;
  width: 70px;
  border-radius: 35px;
  padding-top: 5px;
  color: white;
}
.circle-icon {
  height: 60px;
  width: 60px;
  border-radius: 30px;
  margin: auto;
  line-height: 60px;
  text-align: center;
  border: solid 5px white;
}
</style>
